// extracted by mini-css-extract-plugin
export default {"form":"styles_form__-S3b1","button":"styles_button__F3ZLH","center":"styles_center__bvVQC","fileInput":"styles_fileInput__7GEPD"};